<div class="row">
  <div [class]="satinAlmaButtons ? 'col-md-8' : 'col-md-12'">
    <div class="table-responsive" >
      <h2 class="title-irsaliye">İrsaliye Listesi <span> Aradığınız irsaliye yok ise buraya<span (click)="senkronIrsaliye"> tıklayın </span>.</span></h2>

      <div class="row" *ngIf="satinAlmaButtons === true ">
        <div class="col-md-3" *ngIf="irsaliyeList">
          <button class="btn btn-primary btn-sm" type="button" (click)="addRange()">Seçilenleri Ekle</button>
        </div>
        <div class="col-md-3">
          <input mwlFlatpickr class="form-control mb-2 flatpickr-input" type="text" placeholder="Başlangıç Tarihi"
            [altInput]="true" [convertModelValue]="true"
            [(ngModel)]="baslangicTarih"
            (input)="dateChange()">
        </div>
        <div class="col-md-3">
          <input mwlFlatpickr class="form-control mb-2 flatpickr-input" type="text" placeholder="Bitiş Tarihi"
            [altInput]="true" [convertModelValue]="true"
            [(ngModel)]="bitisTarihi"
            (input)="dateChange()">
        </div>
      </div>


      <table class="table card-table table-vcenter text-nowrap datatable" *ngIf="satinAlmaButtons === true && irsaliyeList">
        <thead>
          <tr>
            <!-- <th class="w-1">Id</th> -->
            <th>Seç</th>
            <th>Araç</th>
            <th>Tarih</th>
            <th>İrsaliye No</th>
            <th>Müşteri</th>
            <th>stokAdi</th>
            <th>Miktar</th>
            <th>Dolu / Dolu</th>
            <th>Düzenlenen Miktar</th>
            <th>Birim Fiyat</th>
            <th>Tutar</th>
            <th>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let i of irsaliyeList">
            <td><input type="checkbox" (change)="onSaveCheckboxChange(i)" name="test" /></td>
            <td>{{ i.lojistik.plaka }} </td>
            <td>{{ i.lojistik.irsaliyeTarih | date:'dd.MM.yyyy' }}</td>
            <td>{{ i.lojistik.irsaliyeNo }}</td>
            <td>{{ i.lojistik.cariUnvan }}</td>
            <td>{{i.lojistik.stokAdi}}</td>
            <td>{{i.lojistik.miktar}}</td>
            <td> <input type="checkbox" (change)="isDonus(i.lojistik)"  [disabled]="i.birimFiyat?.doluDoluFiyat == 0"   [(ngModel)]="i.lojistik.donus" name="test" /> </td>
            <td>{{i.lojistik.customMiktar}}</td>
            <td>{{gercekFiyat(i.lojistik.donus ? i.birimFiyat?.doluDoluFiyat :  i.birimFiyat?.bosDoluFiyat , i.aktifMazotFiyat)}}</td>
            <td>{{customParseFloat(i.lojistik.donus ? i.birimFiyat?.doluDoluFiyat :  i.birimFiyat?.bosDoluFiyat , i.aktifMazotFiyat, i.lojistik.miktar, i.lojistik.customMiktar)}}</td>
            <td class="text-right">
              <div class="btn btn-sm btn-primary ml-2" (click)="editMiktar(i)">Miktar Düzenle</div>
              <div class="btn btn-sm btn-success ml-2" (click)="ekle(i)">Ekle</div>
            </td>
          </tr>
        </tbody>
      </table>

      <div *ngIf="satinAlmaButtons === false">
        <div *ngFor="let i of distinctFaturaName">
          <h3>{{i}}</h3>

          <table class="table card-table table-vcenter text-nowrap datatable">
            <thead>
              <tr>
                <!-- <th class="w-1">Id</th> -->
                <th>Araç</th>
                <th>Tarih</th>
                <th>İrsaliye No</th>
                <th>Müşteri</th>
                <th>stokAdi</th>
                <th>Miktar</th>
                <th>Birim Fiyat</th>
                <th>Tutar</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of (irsaliyeList | faturaFilter:i)">
                <td>{{ item.plaka }}</td>
                <td>{{ item.irsaliyeTarih | date:'dd.MM.yyyy' }}</td>
                <td>{{ item.irsaliyeNo }}</td>
                <td>{{ item.cariUnvan }}</td>
                <td>{{item.stokAdi}}</td>
                <td>{{item.miktar}}</td>
                <td>{{item.birimFiyat}}</td>
                <td>{{item.toplamFiyat}}</td>
              </tr>
              <tr>
                <td colspan="7">Toplam Tutar</td>
                <td>{{toplamTutarParse(irsaliyeList | faturaFilter:i)}}</td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>
  </div>

  <div class="col-md-4" *ngIf="satinAlmaButtons">
    <div class="table-responsive" *ngIf="faturalandirilacakIrsaliyeler">
      <h2>Eklenen İrsaliye</h2>
      <button class="btn btn-primary mb-1 btn-sm" type="button" (click)="removeRange()">Seçilenleri Kaldır</button>
      <table class="table card-table table-vcenter text-nowrap datatable">
        <thead>
          <tr>
            <th>Seç</th>
            <th>Tarih</th>
            <th>İrsaliye No</th>
            <th>Dolu / Dolu</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let i of faturalandirilacakIrsaliyeler; let index = index">
            <td><input type="checkbox" (change)="onRemoveCheckboxChange(i)" name="test" /></td>
            <td>{{ i.lojistik.irsaliyeTarih | date:'dd.MM.yyyy' }}</td>
            <td>{{ i.lojistik.irsaliyeNo }}</td>
            <td>
              <input type="checkbox" disabled [(ngModel)]="i.lojistik.donus" />
            </td>
            <td class="text-right">
              <div class="btn btn-sm btn-danger" (click)="kaldir(index)">Kaldır</div>
            </td>
          </tr>
          <tr *ngIf="faturalandirilacakIrsaliyeler.length > 0">
            <td class="text-right" colspan="3">
              <div class="btn btn-sm btn-success" (click)="faturalandirFirst()">Faturalandır</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="content" *ngIf="faturalandirFirstStep">
  <div class="title">Fatura isimlendir </div>
  <div class="row">
    <div class="col-md-12">
      <form action="#">
        <input [(ngModel)]="faturaAdi" [ngModelOptions]="{standalone: true}" class="form-control"
          placeholder="Fatura ismi">
      </form>
    </div>
    <div class="col-md-12">
      <button type="button" (click)="faturalandirLast()"> İrsaliyeleri Faturalandır </button>
    </div>
  </div>
</div>

<div class="content" *ngIf="ctrlIrsaliyeDuzenle">
  <div class="title">Miktar Düzenle</div>
  <div class="row">
    <div class="col-md-12">
      <form action="#">
        <input [(ngModel)]="irsaliyeDuzenle.lojistik.customMiktar" [ngModelOptions]="{standalone: true}" class="form-control"
          placeholder="Mütabakat Miktar">
      </form>
    </div>
    <div class="col-md-12">
      <button type="button" (click)="miktarSave()"> Kaydet </button>
    </div>
  </div>
</div>